export const MCP_NOT_FOUND_DOCUMENT = 'Document not found.';
export const MCP_NOT_FOUND_LOCALE = 'Document locale not found.';
export const MCP_NOT_FOUND_OR_PUBLISHED = 'Document not found or already published.';
